import { loginAPI } from '../api/LoginAPI'
import { useUserStore } from '@/store/useUserStore'
import type { dataTable } from '../types/types'

export function useLogin() {
  const UserStore = useUserStore()
  
  const onLogin = async (username: string, password: string) => {
    try {
      const result = await loginAPI(username, password)
      if (result) {
        result.config = JSON.parse(atob(result.config))
        result.role = JSON.parse(atob(result.role))
        UserStore.itemPerPage = result.config.tablesize
        UserStore.siblingCount = result.config.pnbtncount
        UserStore.account = result.account
        UserStore.isLoggedIn = true
        await applyRole(result.role.admin, result.role.dataTable, result.role.menus)
      } else {
        console.log("로그인 실패, 입력값 확인 필요")
        UserStore.isLoggedIn = false
      }
    } catch (e) {
      console.error("로그인 중 에러 발생:", e)
    }
  }

  // 권한 적용 함수 
  const applyDeny = (perms: string[] | undefined, suffix: string) => {
    if (!perms) return
    for (const perm of perms) {
      const storeKey = `${perm}${suffix}` as keyof typeof UserStore
      if (storeKey in UserStore) {
        (UserStore as any)[storeKey] = true
      }
    }
  }

  // 역할과 권한을 UserStore에 적용하는 함수
  const applyRole = (role: number, permissions: dataTable, hiddenMenus: string[]) => {
    UserStore.menus = hiddenMenus;
    UserStore.menus.push('settings')
    if (role === 1) {
      UserStore.role = 1;
      applyDeny(permissions?.add, 'Add')
      applyDeny(permissions?.edit, 'Edit')
      applyDeny(permissions?.delete, 'Delete')
      UserStore.menus.push('users','roles')
    }
    else {
      UserStore.role = 2;
    }
      applyDeny(permissions?.add, 'Add')
      applyDeny(permissions?.edit, 'Edit')
      applyDeny(permissions?.delete, 'Delete')
    return

  }

  return { onLogin , applyRole }
}